module.exports = __webpack_public_path__ + "static/media/sign-out.28540e11.svg";